// 마운트/배터리 타입별 색상 — 단일 정의, 두 곳에서 import해서 사용
const mountColors = {
  // Canon
  'RF': '#FF6B35',
  'EF': '#F7931E',
  'EF-S': '#E65100',
  'EF-M': '#FF8A65',
  // Sony
  'E-mount': '#1976D2',
  'E': '#1976D2',
  'FE': '#1565C0',
  'A-mount': '#0D47A1',
  // Nikon
  'Z-mount': '#9C27B0',
  'Z': '#9C27B0',
  'F-mount': '#4CAF50',
  '니콘 F': '#9C27B0',
  'DX': '#388E3C',
  'FX': '#2E7D32',
  // 기타 마운트
  'L-mount': '#795548',
  'L': '#795548',
  'MFT': '#607D8B',
  'M43': '#607D8B',
  'Micro Four Thirds': '#607D8B',
  // Fujifilm
  'X-mount': '#E91E63',
  'X': '#E91E63',
  'GFX': '#C2185B',
  // Panasonic
  'Lumix': '#FF5722',
  // 기타
  'PL': '#00BCD4',
  'C-mount': '#009688',
  'CS-mount': '#00695C',
  'B4': '#3F51B5',
  'ENG': '#673AB7',
  // 필터 사이즈
  '67mm': '#FFC107',
  '77mm': '#FF9800',
  '82mm': '#FF5722',
  '95mm': '#9E9E9E',
  // 배터리
  'LP-E6': '#8BC34A',
  'LP-E6N': '#689F38',
  'LP-E6NH': '#558B2F',
  'NP-FZ100': '#2196F3',
  'NP-W235': '#1976D2',
  'EN-EL15': '#4CAF50',
  // 일반 용어
  '풀프레임': '#9C27B0',
  '크롭': '#FF9800',
  '시네마': '#424242',
  '스튜디오': '#795548',
  'DSLR': '#607D8B',
  '미러리스': '#3F51B5',
  '기타': '#757575',
};

export default mountColors;
